export default __webpack_public_path__ + "static/media/Path 126.36e0d167.svg";